import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SET_IS_CURATION_ENABLED_AWARD_MUTATION } from '../graphql/mutations'
import { SET_IS_CURATION_ENABLED_AWARD } from '../redux/action-types'

const useSetIsCurationEnabledAwardMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.awards.awards)

  const mutate = useCallback(
    async (id, isCurationEnabled) => {
      await apolloService.mutate(
        SET_IS_CURATION_ENABLED_AWARD_MUTATION,
        {
          id,
          isCurationEnabled,
        },
        dispatch,
        SET_IS_CURATION_ENABLED_AWARD,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSetIsCurationEnabledAwardMutation
